// extracted by mini-css-extract-plugin
export default {"pronounsButton":"ZeKAq8gqHm90SFYIATux","customPronouns":"w1wDppoRyODDmqz9FIl3","tooltip":"l9hI4QIcd307sPsfBjiZ"};